// extracted by mini-css-extract-plugin
module.exports = {"container":"v_input_age_container__IkwH5","input":"v_input_age_input__2cRI-","input_center":"v_input_age_input_center__3dxEF"};